
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","viewBox":"0 0 21 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.134 18.13H13.34l-2.884-4.423-2.834 4.423H1l6.011-8.7L1.366 1h6.598l2.492 4.032L12.95 1h6.672l-5.547 8.162 6.06 8.968z","stroke":"#FF5F3C","stroke-width":".48","stroke-miterlimit":"10"}})])
          )
        }
      }
    